import { render, staticRenderFns } from "./FriendsList.vue?vue&type=template&id=1fbd8862&scoped=true"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"
import style0 from "./FriendsList.vue?vue&type=style&index=0&id=1fbd8862&lang=scss"
import style1 from "./FriendsList.vue?vue&type=style&index=1&id=1fbd8862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd8862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbd8862')) {
      api.createRecord('1fbd8862', component.options)
    } else {
      api.reload('1fbd8862', component.options)
    }
    module.hot.accept("./FriendsList.vue?vue&type=template&id=1fbd8862&scoped=true", function () {
      api.rerender('1fbd8862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/FriendsList.vue"
export default component.exports